import { render, staticRenderFns } from "./balance-trans-detail.vue?vue&type=template&id=d2ba757e&scoped=true"
import script from "./balance-trans-detail.vue?vue&type=script&lang=js"
export * from "./balance-trans-detail.vue?vue&type=script&lang=js"
import style0 from "./balance-trans-detail.vue?vue&type=style&index=0&id=d2ba757e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ba757e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2ba757e')) {
      api.createRecord('d2ba757e', component.options)
    } else {
      api.reload('d2ba757e', component.options)
    }
    module.hot.accept("./balance-trans-detail.vue?vue&type=template&id=d2ba757e&scoped=true", function () {
      api.rerender('d2ba757e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/financials-agent/balance-trans-detail.vue"
export default component.exports